export const DASHBOARD_ACTIONS = {
  CHANGE_SCHEMA: 'changeSchema',
  CLONE_SET: 'cloneSet',
  CLONE_PORTAL: 'clone',
  DELETE_SHARE_KEY: 'deleteShareKey',
  RECEIVE_TITLE: 'receiveTitle',
  REQUEST_SHARE_UI: 'requestShare',
  REQUEST_SHARE_URL: 'requestShareURL',
  RESET_SCHEMA: 'resetSchema',
  SEND_INVITATION: 'sendInvitation',
  SEND_SCHEMA: 'sendSchema',
  SEND_SOURCE: 'sendSource',
  SEND_REPORTS_ORDER: 'sendReportsOrder',
  STORE_SHARE_KEY: 'storeShareKey',
  UPDATE_BACKEND_RESULT: 'updateBackendResult',
  UPDATE_DASHBOARD: 'updateDashboard',
  UPDATE_TITLE: 'updateTitle'
} as const

export type DashboardActionsType = (typeof DASHBOARD_ACTIONS)[keyof typeof DASHBOARD_ACTIONS]
